import { Link } from "react-router-dom";
import PageBanner from "../components/PageBanner";

export default function Join() {
  return (
    <div className="inner-page">
      <PageBanner title="加入我们" en="CAREERS" variant="join" />
      <section className="panel">
        <div className="container">
          <h2 className="small-title">选择你的加入方式</h2>
          <div className="job-entry">
            <Link to="/job?tab=campus" className="job-card">
              <span>Campus</span>
              <h3>校园招聘</h3>
              <p>面向海南及全国高校，开放产品、技术、设计与运营实习与校招岗位。</p>
            </Link>
            <Link to="/job?tab=social" className="job-card">
              <span>Social</span>
              <h3>社会招聘</h3>
              <p>寻找数字文旅、XR、空间计算与内容运营方向的专业伙伴。</p>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
